<template>
  <div>
    <!-- Start Breadcrump Area  -->
    <N2CabezaPagina v-if="disenoPropio" titulo="Protección de Datos" />
    <div v-else
      class="rn-page-title-area pt--120 pb--190 banner-service-details-notin"
      data-black-overlay="5"
    >
      <v-container>
        <v-row>
          <v-col cols="12">
            <div class="rn-page-title text-center pt--100">
              <h1 class="headingtitle">Protección de Datos</h1>
            </div>
          </v-col>
        </v-row>
      </v-container>
    </div>
    <!-- End Breadcrump Area  -->

    <div class="rn-service-details rn-section-gap bg_color--1 content-service-details-notin">
      <v-container>
        <v-row>
          <v-col lg="12">
            <div class="inner">
              <!-- Start Single Content  -->
              <v-row
                class="pb--80 align-items-center text-justify"
              >
                <v-col lg="12" md="12" cols="12">
                  <div class="contentlegal details mt_md--30 mt_sm--30" v-if="NOTARIA.LopdPage && NOTARIA.LopdPage.trim() !== ''" v-html="htmlLegal(NOTARIA.LopdPage)"></div>
                  <div class="contentlegal details mt_md--30 mt_sm--30" v-else>
                    <h2>POLÍTICA DE PRIVACIDAD</h2>
                    <h3>INFORMACIÓN BÁSICA SOBRE PROTECCIÓN DE DATOS</h3>

                    <table class="table mb--30" style="width: 100%; border-collapse: collapse; border: 1px solid #ddd; margin-bottom: 30px;">
                        <tr style="border-bottom: 1px solid #ddd;">
                            <td style="padding: 12px; font-weight: bold; width: 30%; background-color: #f9f9f9; border-right: 1px solid #ddd;">Responsable</td>
                            <td style="padding: 12px; border-bottom: 1px solid #ddd;">UNIVERSAL DATA S.L.</td>
                        </tr>
                        <tr style="border-bottom: 1px solid #ddd;">
                            <td style="padding: 12px; font-weight: bold; background-color: #f9f9f9; border-right: 1px solid #ddd;">Finalidad</td>
                            <td style="padding: 12px; border-bottom: 1px solid #ddd;">Gestión del directorio de notarías, atención de consultas y contactos a través de los formularios</td>
                        </tr>
                        <tr style="border-bottom: 1px solid #ddd;">
                            <td style="padding: 12px; font-weight: bold; background-color: #f9f9f9; border-right: 1px solid #ddd;">Legitimación</td>
                            <td style="padding: 12px; border-bottom: 1px solid #ddd;">Consentimiento del interesado y ejecución de medidas precontractuales</td>
                        </tr>
                        <tr style="border-bottom: 1px solid #ddd;">
                            <td style="padding: 12px; font-weight: bold; background-color: #f9f9f9; border-right: 1px solid #ddd;">Destinatarios</td>
                            <td style="padding: 12px; border-bottom: 1px solid #ddd;">Los datos proporcionados a través del formulario de contacto de cada notaría que conforma el directorio serán remitidos a la misma</td>
                        </tr>
                        <tr style="border-bottom: 1px solid #ddd;">
                            <td style="padding: 12px; font-weight: bold; background-color: #f9f9f9; border-right: 1px solid #ddd;">Derechos</td>
                            <td style="padding: 12px; border-bottom: 1px solid #ddd;">Acceder, rectificar y suprimir los datos, así como otros derechos, como se explica en la información adicional</td>
                        </tr>
                        <tr style="border-bottom: 1px solid #ddd;">
                            <td style="padding: 12px; font-weight: bold; background-color: #f9f9f9; border-right: 1px solid #ddd;">Delegado de Protección de Datos</td>
                            <td style="padding: 12px; border-bottom: 1px solid #ddd;"><a :href="`mailto:${correoDpo}`">{{ correoDpo }}</a></td>
                        </tr>
                        <tr>
                            <td style="padding: 12px; font-weight: bold; background-color: #f9f9f9; border-right: 1px solid #ddd;">Información adicional</td>
                            <td style="padding: 12px;">Puede consultar la información adicional y detallada sobre protección de datos a continuación</td>
                        </tr>
                    </table>

                    <h3 class="mt--30">INFORMACIÓN ADICIONAL SOBRE PROTECCIÓN DE DATOS</h3>

                    <h4 class="mt--20 text-primary">1. RESPONSABLE DEL TRATAMIENTO</h4>
                    <p>Identidad: UNIVERSAL DATA S.L.<br>
                    NIF/CIF: B-30417778<br>
                    Dirección postal: GLORIETA DE QUEVEDO, 5, BAJO, 28015 Madrid<br>
                    <template v-if="!esMinotaria">Teléfono: 900732022<br></template>
                    Correo electrónico: <a :href="`mailto:${correo}`">{{ correo }}</a><br>
                    Delegado de Protección de Datos: Puede contactar con el DPO en <a :href="`mailto:${correoDpo}`">{{ correoDpo }}</a></p>

                    <h4 class="mt--20 text-primary">2. FINALIDAD DEL TRATAMIENTO</h4>
                    <p>En UNIVERSAL DATA S.L. tratamos la información que nos facilita con la finalidad de:</p>
                    <ul>
                        <li>Gestionar el directorio de notarías y mantenerlo actualizado.</li>
                        <li>Tramitar y responder a las solicitudes de información, consultas o reclamaciones realizadas a través de los formularios de contacto.</li>
                        <li>Remitir a la notaría correspondiente los datos proporcionados a través del formulario de contacto específico de cada notaría que conforma el directorio.</li>
                        <li>Mejorar la experiencia de navegación del usuario.</li>
                        <li>Elaborar estadísticas de uso anónimas para mejorar nuestros servicios.</li>
                    </ul>
                    <p>Plazos de conservación de los datos: Los datos personales proporcionados se conservarán mientras se mantenga la relación con el usuario, mientras no se solicite su supresión por el interesado o durante el tiempo necesario para cumplir con las obligaciones legales.</p>

                    <h4 class="mt--20 text-primary">3. LEGITIMACIÓN PARA EL TRATAMIENTO DE SUS DATOS</h4>
                    <p>La base legal para el tratamiento de sus datos es:</p>
                    <ul>
                        <li>El consentimiento del interesado para el tratamiento de sus datos personales para uno o varios fines específicos al rellenar los formularios del sitio web.</li>
                        <li>La ejecución de medidas precontractuales adoptadas a petición del interesado, cuando la finalidad sea la de atender una consulta o solicitud realizada a través del formulario de contacto.</li>
                        <li>El interés legítimo de UNIVERSAL DATA S.L. para gestionar y mantener actualizado el directorio de notarías, así como para mejorar la experiencia de navegación del usuario.</li>
                    </ul>

                    <h4 class="mt--20 text-primary">4. DESTINATARIOS DE SUS DATOS</h4>
                    <p>Los datos personales tratados por UNIVERSAL DATA S.L. podrán ser comunicados a:</p>
                    <ul>
                        <li>Las notarías que forman parte del directorio, cuando los datos sean proporcionados a través del formulario de contacto específico de cada notaría.</li>
                        <li>Proveedores de servicios que actúan como encargados de tratamiento y con los que UNIVERSAL DATA S.L. ha suscrito los correspondientes contratos de encargado de tratamiento conforme a las exigencias del artículo 28 del RGPD .</li>
                        <li>Organismos y autoridades públicas, en caso de que exista una obligación legal para ello.</li>
                    </ul>
                    <p>No se realizarán transferencias internacionales de datos, salvo obligación legal.</p>

                    <h4 class="mt--20 text-primary">5. DERECHOS EN MATERIA DE PROTECCIÓN DE DATOS</h4>
                    <p>Cualquier persona tiene derecho a obtener información sobre si UNIVERSAL DATA S.L. está tratando datos personales que le conciernan o no. Las personas interesadas tienen derecho a:</p>
                    <ul>
                        <li>Acceder a sus datos personales.</li>
                        <li>Rectificar los datos inexactos.</li>
                        <li>Solicitar la supresión de los datos cuando, entre otros motivos, los datos ya no sean necesarios para los fines para los que fueron recogidos.</li>
                        <li>Solicitar la limitación del tratamiento de sus datos.</li>
                        <li>Oponerse al tratamiento de sus datos.</li>
                        <li>Solicitar la portabilidad de los datos.</li>
                        <li>Retirar el consentimiento prestado en cualquier momento.</li>
                        <li>Presentar una reclamación ante la Autoridad de Control (en España, la Agencia Española de Protección de Datos, <a href="https://www.aepd.es" target="_blank">www.aepd.es</a>) si considera que el tratamiento no se ajusta a la normativa vigente.</li>
                    </ul>

                    <h4 class="mt--20 text-primary">6. ¿CÓMO EJERCER SUS DERECHOS?</h4>
                    <p>Los derechos anteriormente descritos pueden ejercerse dirigiendo una comunicación por escrito a:</p>
                    <ul>
                        <li>Dirección postal: UNIVERSAL DATA S.L., GLORIETA DE QUEVEDO, 5, BAJO, 28015 Madrid</li>
                        <li>Correo electrónico: <a :href="`mailto:${correoDpo}`">{{ correoDpo }}</a> (Delegado de Protección de Datos)</li>
                    </ul>
                    <p>Para ejercitar sus derechos deberá identificarse mediante copia de DNI o documento equivalente o firma electrónica.</p>

                    <h4 class="mt--20 text-primary">7. PROCEDENCIA DE LOS DATOS</h4>
                    <p>Los datos personales que tratamos en UNIVERSAL DATA S.L. proceden de:</p>
                    <ul>
                        <li>El propio interesado, que los facilita a través de los formularios de contacto o de consulta del sitio web.</li>
                        <li>Fuentes de acceso público para la información relacionada con las notarías que conforman el directorio.</li>
                    </ul>
                    <p>Las categorías de datos que tratamos son:</p>
                    <ul>
                        <li>Datos identificativos: nombre, apellidos, DNI/NIE, teléfono, dirección postal y electrónica.</li>
                        <li>Datos relacionados con la consulta: aquellos que el interesado nos facilite voluntariamente en relación con su consulta o solicitud de información.</li>
                        <li>Datos de navegación: dirección IP, tipo de navegador, duración de la visita, páginas visitadas, etc.</li>
                    </ul>

                    <h4 class="mt--20 text-primary">8. MEDIDAS DE SEGURIDAD</h4>
                    <p>UNIVERSAL DATA S.L. ha adoptado las medidas técnicas y organizativas necesarias para garantizar la seguridad de los datos de carácter personal y evitar su alteración, pérdida, tratamiento o acceso no autorizado, teniendo en cuenta el estado de la tecnología, la naturaleza de los datos almacenados y los riesgos a que estén expuestos.</p>

                    <h4 class="mt--20 text-primary">9. INFORMACIÓN SOBRE COOKIES</h4>
                    <p>Utilizamos cookies propias y de terceros para mejorar nuestros servicios y mostrarle publicidad relacionada con sus preferencias mediante el análisis de sus hábitos de navegación. Si continúa navegando, consideramos que acepta su uso. Puede obtener más información en nuestra Política de Cookies, donde podrá conocer cómo cambiar la configuración o rechazar su uso.</p>

                    <h4 class="mt--20 text-primary">10. ACTUALIZACIÓN DE LA POLÍTICA DE PRIVACIDAD</h4>
                    <p>Es posible que se deba actualizar esta Política de Privacidad; por ello es necesario que revise esta política periódicamente y si es posible cada vez que acceda a nuestro sitio web con el objetivo de estar informado sobre cómo utilizamos sus datos personales.</p>
                    <p>Esta Política de Privacidad fue actualizada por última vez en Noviembre de 2025</p>
                  </div>
                </v-col>
              </v-row>
              <!-- End Single Content  -->
            </div>
          </v-col>
        </v-row>
      </v-container>
    </div>
  </div>
</template>

<script setup lang="ts">
// Plantillas 2 a 5: cabecera de página de la plantilla; el texto toma sus colores y fuentes (assets/notaria2.scss)
import N2CabezaPagina from '../components/notaria2/N2CabezaPagina.vue'
import { useDisenoPropio } from '../composables/useNotaria2'
const disenoPropio = useDisenoPropio()
import { useStore } from '../store/index'
import { useContactoLegal } from '../composables/useContactoLegal'
const store = useStore();
const { NOTARIA } = storeToRefs(store) as any
const { esMinotaria, correo, correoDpo, htmlLegal } = useContactoLegal()

const PageName = "protecciondatos"
if(store.NOTARIA) useMetaTags(toRaw(store.NOTARIA),PageName)
</script>
